var map = {
	"./de/download-btn.png": "0FAt",
	"./en/download-btn.png": "mn7O",
	"./es/download-btn.png": "DFIp",
	"./fr/download-btn.png": "iDfY",
	"./ja/download-btn.png": "2+9N",
	"./ko/download-btn.png": "0Hyq",
	"./pt/download-btn.png": "rERS",
	"./ru/download-btn.png": "6PGK",
	"./tc/download-btn.png": "QNFn",
	"./th/download-btn.png": "7xjm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qJHV";